export default {
  Info: 'Info',
  Warn: 'Warn',
  Error: 'Error',
};
